import { Component, OnInit, OnChanges, Input } from '@angular/core';
import { URLSearchParams } from '@angular/http';
import { SalesTeamReportService } from '../../../services/index';
import * as moment from 'moment';

@Component({
    selector: 'sales-team-report-tab',
    templateUrl: './salesTeamReport.component.html'
})
export class SalesTeamReportComponent implements OnInit, OnChanges {
    @Input('tabTitle') title: string;
    @Input() active = false;
    @Input() isCloseable = false;
    @Input() dataContext;

    isLoading = false;
    reportData: any[] = [];
    monthLabel = '';
    initialized = false;

    months = [
        { value: 1,  label: 'January' },
        { value: 2,  label: 'February' },
        { value: 3,  label: 'March' },
        { value: 4,  label: 'April' },
        { value: 5,  label: 'May' },
        { value: 6,  label: 'June' },
        { value: 7,  label: 'July' },
        { value: 8,  label: 'August' },
        { value: 9,  label: 'September' },
        { value: 10, label: 'October' },
        { value: 11, label: 'November' },
        { value: 12, label: 'December' }
    ];

    years: number[] = [];

    filterData: any = {
        month: new Date().getMonth() + 1,
        year:  new Date().getFullYear()
    };

    constructor(private salesTeamReportSer: SalesTeamReportService) {
        const currentYear = new Date().getFullYear();
        for (let y = currentYear; y >= currentYear - 10; y--) {
            this.years.push(y);
        }
    }

    ngOnInit() { }

    ngOnChanges() {
        if (this.active && !this.initialized) {
            this.initialized = true;
            this.loadReport();
        }
    }

    loadReport() {
        this.isLoading = true;
        this.reportData = [];
        this.salesTeamReportSer.getSalesTeamIndividualReport({
            month: this.filterData.month,
            year:  this.filterData.year
        }).then(res => {
            this.isLoading = false;
            if (res && res.success) {
                this.reportData = res.data || [];
                this.monthLabel = res.month_label || '';
            }
        }).catch(() => { this.isLoading = false; });
    }

    getMonthName(): string {
        const m = this.months.find(x => x.value === +this.filterData.month);
        return m ? m.label : '';
    }

    // Returns 'green', 'red', or '' for percentage cells
    pctClass(value: number, target: number): string {
        if (target === null) return '';
        const v = (value === null || value === undefined) ? 0 : value;
        return v >= target ? 'pct-green' : 'pct-red';
    }

    formatPct(value: number): string {
        if (value === null || value === undefined) return '0%';
        return value + '%';
    }

    exportExcel() {
        const p = new URLSearchParams();
        p.set('month', this.filterData.month);
        p.set('year',  this.filterData.year);
        window.open(`api/salesTeamReport/exportExcel?${p.toString()}`, '_blank');
    }

    isOthers(row: any): boolean { return row.is_others === true; }
    isTotal(row: any): boolean  { return row.is_total  === true; }
}



// WEBPACK FOOTER //
// /Applications/MAMP/htdocs/crm-soundsgood/src/app/components/reports/salesTeamReport/salesTeamReport.component.ts